import { Images } from "constants";
import React from "react";

const Loading = () => {
    return <>
    {/* <td colSpan="100%" className="loaderBg" style={{ textAlign: "center" }}> */}
            <img className="_loadWidth" src={Images.LOADINGTRUCK} alt="" />
            {/* </td> */}
    </>
};

export default Loading;
